import { Injectable } from '@angular/core';
import { UserService, ApiService } from '../..';
import { isFulfilled } from '../../../../../node_modules/@types/q';

@Injectable()
export class ChiSoCongToKHService {

  constructor(private api: ApiService, public user: UserService) { }

  getChiSoCongToKH(danhmucid, loaihienthi, ngay, gio, loaipha, sotrang, sodong, locdulieu, loaichiso, duan) {
    let curUs = this.user.getCurrentUser();
    var param = {
      config: JSON.stringify({ namesql: "PKG_THONGSOVANHANH.P_LAYDS_CHISOCTO" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid,
        v_locdulieu: locdulieu,
        v_loaihienthi: loaihienthi,
        v_ngay: ngay,
        v_gio: gio,
        v_loaipha: loaipha,
        v_sotrang: sotrang,
        v_sodong: sodong,
        v_mataikhoan: curUs.mataikhoan,
        v_ip: "",
        v_loaichiso: loaichiso,
        v_duan: duan
      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }


  get_GiamSatCamBien(danhmucid, ngay, sotrang, sodong) {
    let curUs = this.user.getCurrentUser();
    var param = {
      config: JSON.stringify({ namesql: "PKG_GIAMSATCAMBIEN.P_GET_GIAMSAT_CAMBIEN" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid,
        v_ngay: ngay,
        v_sotrang: sotrang,
        v_sodong: sodong

      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }

  getDsIMEI(danhmucid) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_GIAMSAT.P_GET_IMEI" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid
      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }

  getDsManHinhGiamSat(danhmucid, imei) {
    var param = {
      //config: JSON.stringify({ namesql: "PKG_GIAMSAT.P_GIAMSAT_MANHINH" }),
      config: JSON.stringify({ namesql: "PKG_A_SBM_RTU.P_GIAMSAT_MANHINH" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid,
        v_imei: imei
      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }
  getVitri_TrongTram(imei) {

    var param = {
      config: JSON.stringify({ namesql: "PKG_GIAMSATCAMBIEN_TRAM.Lay_vitri" }),
      para: JSON.stringify({
        v_imei: imei

      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }

  get_dulieu_bieudo_vitri_trongtram(tungay, denngay, imei) {

    var param = {
      config: JSON.stringify({ namesql: "PKG_GIAMSATCAMBIEN_TRAM.P_DULIEU_BIEUDO_TRAM" }),
      para: JSON.stringify({
        v_imei: imei,
        v_tungay: tungay,
        v_denngay: denngay

      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }


  get_GiamSatCamBien_Chitiet_TheoTram(tungay, denngay, imei, sotrang, sodong) {

    var param = {
      config: JSON.stringify({ namesql: "PKG_GIAMSATCAMBIEN_TRAM.P_GET_CHITIET_TRAM" }),
      para: JSON.stringify({
        v_imei: imei,
        v_tungay: tungay,
        v_denngay: denngay

      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }

  get_GiamSatCamBien_Chitiet(tungay, denngay, imei, id_cambien, sotrang, sodong) {

    var param = {
      config: JSON.stringify({ namesql: "PKG_GIAMSATCAMBIEN.P_GET_CAMBIEN_CHITIET" }),
      para: JSON.stringify({
        v_imei: imei,
        v_id_cambien: id_cambien,
        v_tungay: tungay,
        v_denngay: denngay,
        v_sotrang: sotrang,
        v_sodong: sodong

      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }

  exportExcel_GiamSatCamBien_Chitiet(tungay, denngay, imei, id_cambien, vitri, sotrang, sodong) {
    let cols = [];

    cols = [
      { "name": "STT", "label": "STT", "horizontalalignment": "center" },

      // { "name": "dienap_pin", "label": "Điện áp pin", "horizontalalignment": "center" },
      // { "name": "rssi", "label": "RSSI", "horizontalalignment": "center" },
      { "name": "istime", "label": "Thời gian", "horizontalalignment": "center" },
      { "name": "nhietdo", "label": "Nhiệt độ", "horizontalalignment": "center" },

    ]

    // let curUs = this.user.getCurrentUser();
    let para: any = JSON.stringify({
      v_imei: imei,
      v_id_cambien: id_cambien,
      v_tungay: tungay,
      v_denngay: denngay,
      v_sotrang: 0,
      v_sodong: 10000000,


    });
    let config = JSON.stringify({ namesql: "PKG_GIAMSATCAMBIEN.P_GET_CAMBIEN_CHITIET" });

    let dateNow = new Date();
    let strDate = "";

    strDate = dateNow.getDate() + "-" + (dateNow.getMonth() + 1) + "-" + dateNow.getFullYear();

    let fileName = vitri + "_" + strDate + ".xlsx";
    var param = {
      config: config,
      para: para,
      title: vitri,
      header: strDate,
      filename: "",
      sheets: "sheet1",
      columns: cols,
      data: ""
    };
    return this.api.downloadFile("api/ExportExcel", param, fileName);

  }


  exportExcel_Chitiet_TheoTram(imei, tungay, denngay, lstdate, tenkhachhang) {


    let cols = [];

    cols.push({ "name": "istime", "label": "Thời gian", "horizontalalignment": "center" })


    for (var i = 0; i < lstdate.length; i++) {
      var tg = "Nhiệt độ " + lstdate[i];
      cols.push({ "name": lstdate[i], "label": tg, "horizontalalignment": "center" });
    }

    let filename = "Báo cáo trạm " + tenkhachhang;
    var param = {
      config: JSON.stringify({ namesql: "PKG_GIAMSATCAMBIEN_TRAM.P_GET_CHITIET_TRAM" }),
      para: JSON.stringify({
        v_imei: imei,
        v_tungay: tungay,
        v_denngay: denngay
      }),
      title: "Báo cáo trạm " + tenkhachhang,
      filename: "Báo cáo trạm " + tenkhachhang,
      header: "Báo cáo trạm " + tenkhachhang + " Ngày: " + tungay,
      sheets: 'baocaotram',
      columns: cols,
      data: ""
    };

    return this.api.downloadFile("api/ExportExcel", param, filename);
  }






  getChiSoCongToKH_Congto2chieu(danhmucid, loaihienthi, ngay, gio, loaipha, sotrang, sodong, locdulieu, loaichiso) {
    let curUs = this.user.getCurrentUser();
    var param = {
      config: JSON.stringify({ namesql: "PKG_THONGSOVANHANH.P_LAYDS_CHISOCTO_KH_CTO_2CHIEU" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid,
        v_locdulieu: locdulieu,
        v_loaihienthi: loaihienthi,
        v_ngay: ngay,
        v_gio: gio,
        v_loaipha: loaipha,
        v_sotrang: sotrang,
        v_sodong: sodong,
        v_mataikhoan: curUs.mataikhoan,
        v_ip: "",
        v_loaichiso: loaichiso
      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }





  getChiTietChiSoCongToKH(meterid, loaihienthi, socongto, tungay, denngay, sotrang, sodong, loaichiso) {
    let curUs = this.user.getCurrentUser();
    var param = {
      config: JSON.stringify({ namesql: "PKG_THONGSOVANHANH.P_LAY_CHISOCTO_KH" }),
      para: JSON.stringify({
        v_meterid: meterid,
        v_loaihienthi: loaihienthi,
        v_socongto: socongto,
        v_tungay: tungay,
        v_denngay: denngay,
        v_sotrang: sotrang,
        v_sodong: sodong,
        v_mataikhoan: curUs.mataikhoan,
        v_ip: "",
        v_loaichiso: loaichiso
      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }

  exportExcelChiSoCongToChiTiet(meterid, loaihienthi, socongto, tungay, denngay, loaipha, tendonvi, tenchucnang, noidungbaocao, thoidiemtruyvan, loaichiso) {
    let cols = [];
    let language = localStorage.getItem("LANGUAGE");
    if (loaipha == 3) {
      if (language == "en") {
        cols = [
          { "name": "stt", "label": "No", "horizontalalignment": "center" },
          { "name": "socongto", "label": "Meter number", "horizontalalignment": "left" },
          { "name": "timemeter", "label": "Meter time", "horizontalalignment": "center" },
          { "name": "time", "label": "Time", "horizontalalignment": "center" },
          { "name": "tu", "label": "TU", "horizontalalignment": "left" },
          { "name": "ti", "label": "TI", "horizontalalignment": "left" },
          { "name": "hsn", "label": "HSN", "horizontalalignment": "left" },
          { "name": "pgiao1", "label": "P import 1 (KWh)", "horizontalalignment": "right" },
          { "name": "pgiao2", "label": "P import 2 (KWh)", "horizontalalignment": "right" },
          { "name": "pgiao3", "label": "P import 3 (KWh)", "horizontalalignment": "right" },
          { "name": "pgiaotong", "label": "Σ P import (KWh)", "horizontalalignment": "right" },
          { "name": "pnhan1", "label": "P export 1 (KVarh)", "horizontalalignment": "right" },
          { "name": "pnhan2", "label": "P export 2 (KVarh)", "horizontalalignment": "right" },
          { "name": "pnhan3", "label": "P export 3 (KVarh)", "horizontalalignment": "right" },
          { "name": "pnhantong", "label": "Σ P export 3 (KVarh)", "horizontalalignment": "right" },
          { "name": "qgiaotong", "label": "ΣQ import (KVarh)", "horizontalalignment": "right" },
          { "name": "qnhantong", "label": "ΣQ export (KVarh)", "horizontalalignment": "right" },
          { "name": "pmax1", "label": "PMax 1 (kW)", "horizontalalignment": "right" },
          { "name": "pmax1_time", "label": "Time PMax 1", "horizontalalignment": "right" },
          { "name": "tyle_phutai1", "label": "Load profile 1 (%)", "horizontalalignment": "right" },
          { "name": "pmax2", "label": "PMax 2 (kW)", "horizontalalignment": "right" },
          { "name": "pmax2_time", "label": "Time PMax 2", "horizontalalignment": "right" },
          { "name": "tyle_phutai2", "label": "Load profile 2 (%)", "horizontalalignment": "right" },
          { "name": "pmax3", "label": "PMax 3 (kW)", "horizontalalignment": "right" },
          { "name": "pmax3_time", "label": "Time PMax 3", "horizontalalignment": "right" },
          { "name": "tyle_phutai3", "label": "Load profile 3 (%)", "horizontalalignment": "right" }

        ];
      } else {
        cols = [
          { "name": "stt", "label": "STT", "horizontalalignment": "center" },
          { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
          { "name": "timemeter", "label": "Thời gian công tơ", "horizontalalignment": "center" },
          { "name": "time", "label": "Thời gian hệ thống", "horizontalalignment": "center" },
          { "name": "tu", "label": "TU công tơ", "horizontalalignment": "left" },
          { "name": "ti", "label": "TI công tơ", "horizontalalignment": "left" },
          { "name": "hsn", "label": "HSN trong công tơ", "horizontalalignment": "left" },
          { "name": "pgiao1", "label": "P giao 1 (KWh)", "horizontalalignment": "right" },
          { "name": "pgiao2", "label": "P giao 2 (KWh)", "horizontalalignment": "right" },
          { "name": "pgiao3", "label": "P giao 3 (KWh)", "horizontalalignment": "right" },
          { "name": "pgiaotong", "label": "Σ P giao (KWh)", "horizontalalignment": "right" },
          { "name": "pnhan1", "label": "P nhận 1 (KVarh)", "horizontalalignment": "right" },
          { "name": "pnhan2", "label": "P nhận 2 (KVarh)", "horizontalalignment": "right" },
          { "name": "pnhan3", "label": "P nhận 3 (KVarh)", "horizontalalignment": "right" },
          { "name": "pnhantong", "label": "Σ P nhận 3 (KVarh)", "horizontalalignment": "right" },
          { "name": "qgiaotong", "label": "ΣQ giao (KVarh)", "horizontalalignment": "right" },
          { "name": "qnhantong", "label": "ΣQ nhận (KVarh)", "horizontalalignment": "right" },
          { "name": "pmax1", "label": "PMax 1 (kW)", "horizontalalignment": "right" },
          { "name": "pmax1_time", "label": "Time PMax 1", "horizontalalignment": "right" },
          { "name": "tyle_phutai1", "label": "Phụ tải biểu 1 (%)", "horizontalalignment": "right" },
          { "name": "pmax2", "label": "PMax 2 (kW)", "horizontalalignment": "right" },
          { "name": "pmax2_time", "label": "Time PMax 2", "horizontalalignment": "right" },
          { "name": "tyle_phutai2", "label": "Phụ tải biểu 2 (%)", "horizontalalignment": "right" },
          { "name": "pmax3", "label": "PMax 3 (kW)", "horizontalalignment": "right" },
          { "name": "pmax3_time", "label": "Time PMax 3", "horizontalalignment": "right" },
          { "name": "tyle_phutai3", "label": "Phụ tải biểu 3 (%)", "horizontalalignment": "right" }

        ];
      }

    }
    else {
      cols = [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "time", "label": "Thời điểm đọc", "horizontalalignment": "center" },
        { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
        { "name": "meterid", "label": "Meterid", "horizontalalignment": "left" },
        { "name": "imei", "label": "IMEI", "horizontalalignment": "left" },
        { "name": "loaicongto", "label": "Loại công tơ", "horizontalalignment": "left" },
        { "name": "pgiaotong", "label": "Chỉ số điện năng", "horizontalalignment": "right" },
      ]
    }
    let curUs = this.user.getCurrentUser();
    let para: any = JSON.stringify({
      v_meterid: meterid,
      v_loaihienthi: loaihienthi,
      v_socongto: socongto,
      v_tungay: tungay,
      v_denngay: denngay,
      v_sotrang: 0,
      v_sodong: 100000000,
      v_mataikhoan: curUs.mataikhoan,
      v_ip: "",
      v_loaichiso: loaichiso
    });
    let config = JSON.stringify({ namesql: "PKG_THONGSOVANHANH.P_LAY_CHISOCTO_KH" });

    let dateNow = new Date();
    let strDate = "";
    if (thoidiemtruyvan != "") {
      strDate = thoidiemtruyvan;
    }
    else {
      strDate = dateNow.getDate() + "-" + (dateNow.getMonth() + 1) + "-" + dateNow.getFullYear();
    }
    let fileName = tendonvi + "_" + tenchucnang + "_" + strDate + ".xlsx";
    var param = {
      config: config,
      para: para,
      title: noidungbaocao + "_" + tendonvi,
      header: strDate,
      filename: "",
      sheets: tenchucnang,
      columns: cols,
      data: ""
    };
    return this.api.downloadFile("api/ExportExcel", param, fileName);

  }



  // exportExcelChiSoCongToKhongCoDL() {
  //   let cols = [
  //     { "name": "stt", "label": "STT", "horizontalalignment": "center" },
  //     { "name": "imei", "label": "IMEI", "horizontalalignment": "left" },
  //     { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
  //     { "name": "loaicongto", "label": "Loại công tơ", "horizontalalignment": "left" },
  //     { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
  //     { "name": "tenkhachhang", "label": "Tên khách hàng", "horizontalalignment": "left" },
  //     { "name": "matram", "label": "Mã trạm", "horizontalalignment": "left" },
  //     { "name": "macot", "label": "Mã cột", "horizontalalignment": "left" },
  //     { "name": "masoghi", "label": "Mã sổ ghi", "horizontalalignment": "left" },
  //     { "name": "marepeater", "label": "Mã repeater", "horizontalalignment": "left" },
  //   ];
  // }



  exportExcelChiSoCongTo_truockhiHienEdit(danhmucid, loaihienthi, ngay, gio, loaipha, sotrang, sodong, locdulieu, loaichiso, duan, tendonvi, tenchucnang, noidungbaocao, thoidiemtruyvan) {
    let cols = [];
    if (locdulieu === "0") {
      if (loaipha == "3") {
        cols = [
          { "name": "stt", "label": "STT", "horizontalalignment": "center" },
          { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
          { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
          { "name": "tenkhachhang", "label": "Tên khách hàng", "horizontalalignment": "left" },
          { "name": "loaicongto", "label": "Loại công tơ", "horizontalalignment": "left" },
          { "name": "time", "label": "Thời gian đọc", "horizontalalignment": "center" },
          { "name": "pgiao1", "label": "BT", "horizontalalignment": "right" },
          { "name": "pgiao2", "label": "CD", "horizontalalignment": "right" },
          { "name": "pgiao3", "label": "TD", "horizontalalignment": "right" },
          { "name": "pgiaotong", "label": "SG", "horizontalalignment": "right" },
          { "name": "qgiaotong", "label": "VC", "horizontalalignment": "right" },
          { "name": "hsn", "label": "HSN", "horizontalalignment": "right" },
          { "name": "macot", "label": "Mã cột", "horizontalalignment": "left" },
          { "name": "masoghi", "label": "Mã sổ ghi", "horizontalalignment": "left" },
          { "name": "matram", "label": "Mã trạm", "horizontalalignment": "left" },
          { "name": "diachi", "label": "Địa chỉ", "horizontalalignment": "left" },
        ];
      } else {
        cols = [
          { "name": "stt", "label": "STT", "horizontalalignment": "center" },
          { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
          { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
          { "name": "tenkhachhang", "label": "Tên khách hàng", "horizontalalignment": "left" },
          { "name": "loaicongto", "label": "Loại công tơ", "horizontalalignment": "left" },
          { "name": "time", "label": "Thời gian đọc", "horizontalalignment": "center" },
          { "name": "pgiaotong", "label": "KT", "horizontalalignment": "right" },
          { "name": "hsn", "label": "HSN", "horizontalalignment": "right" },
          { "name": "macot", "label": "Mã cột", "horizontalalignment": "left" },
          { "name": "masoghi", "label": "Mã sổ ghi", "horizontalalignment": "left" },
          { "name": "matram", "label": "Mã trạm", "horizontalalignment": "left" },
          { "name": "diachi", "label": "Địa chỉ", "horizontalalignment": "left" },
        ];
      }
    }
    else {
      cols = [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "imei", "label": "IMEI", "horizontalalignment": "left" },
        { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
        { "name": "loaicongto", "label": "Loại công tơ", "horizontalalignment": "left" },
        { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
        { "name": "tenkhachhang", "label": "Tên khách hàng", "horizontalalignment": "left" },
        { "name": "matram", "label": "Mã trạm", "horizontalalignment": "left" },
        { "name": "macot", "label": "Mã cột", "horizontalalignment": "left" },
        { "name": "masoghi", "label": "Mã sổ ghi", "horizontalalignment": "left" },
        { "name": "marepeater", "label": "Mã repeater", "horizontalalignment": "left" },
      ];
    }
    let curUs = this.user.getCurrentUser();
    var param = {

      config: JSON.stringify({ namesql: "PKG_THONGSOVANHANH.P_LAYDS_CHISOCTO" }),//
      para: JSON.stringify({
        v_danhmucid: danhmucid,
        v_locdulieu: locdulieu,
        v_loaihienthi: loaihienthi,
        v_ngay: ngay,
        v_gio: gio,
        v_loaipha: loaipha,
        v_sotrang: sotrang,
        v_sodong: sodong,
        v_mataikhoan: curUs.mataikhoan,
        v_ip: "",
        v_loaichiso: loaichiso,
        v_duan: duan

      }),
      title: tenchucnang + " " + tendonvi,//+ " " + thoidiemtruyvan,
      header: "Ngày: " + thoidiemtruyvan,
      filename: tendonvi + "_" + tenchucnang + "_" + thoidiemtruyvan,
      sheets: tenchucnang,
      columns: cols,
      data: ""
    };
    var filename = tendonvi + "_" + tenchucnang + "_" + thoidiemtruyvan;

    return this.api.downloadFile("api/ExportExcel", param, filename);
  }


  exportExcelChiSoCongTo(danhmucid, loaihienthi, ngay, gio, loaipha, sotrang, sodong, locdulieu, loaichiso, duan, tendonvi, tenchucnang, noidungbaocao, thoidiemtruyvan) {
    let cols = [];
    let language = localStorage.getItem("LANGUAGE");
    if (locdulieu === "0") {
      if (language == "en") {
        cols = [
          { "name": "stt", "label": "No", "horizontalalignment": "center" },
          { "name": "madiemdo", "label": "Measurement point code", "horizontalalignment": "left" },
          { "name": "tenkhachhang", "label": "Customer name", "horizontalalignment": "left" },
          { "name": "socongto", "label": "Meter number", "horizontalalignment": "left" },
          { "name": "timemeter", "label": "Meter time", "horizontalalignment": "center" },
          { "name": "time", "label": "Time", "horizontalalignment": "center" },
          { "name": "tu", "label": "TU", "horizontalalignment": "left" },
          { "name": "ti", "label": "TI", "horizontalalignment": "left" },
          { "name": "hsn", "label": "HSN", "horizontalalignment": "left" },
          { "name": "loaicongto", "label": "Meter type", "horizontalalignment": "left" },
          { "name": "pgiao1", "label": "P import 1 (KWh)", "horizontalalignment": "right" },
          { "name": "pgiao2", "label": "P import 2 (KWh)", "horizontalalignment": "right" },
          { "name": "pgiao3", "label": "P import 3 (KWh)", "horizontalalignment": "right" },
          { "name": "pgiaotong", "label": "Σ P import (KWh)", "horizontalalignment": "right" },

          { "name": "pnhan1", "label": "P export 1 (KVarh)", "horizontalalignment": "right" },
          { "name": "pnhan2", "label": "P export 2 (KVarh)", "horizontalalignment": "right" },
          { "name": "pnhan3", "label": "P export 3 (KVarh)", "horizontalalignment": "right" },
          { "name": "pnhantong", "label": "Σ P export 3 (KVarh)", "horizontalalignment": "right" },
          { "name": "qgiaotong", "label": "ΣQ import (KVarh)", "horizontalalignment": "right" },
          { "name": "qnhantong", "label": "ΣQ export (KVarh)", "horizontalalignment": "right" },
          { "name": "pmax1", "label": "PMax 1 (kW)", "horizontalalignment": "right" },
          { "name": "pmax1_time", "label": "Time PMax 1", "horizontalalignment": "right" },
          { "name": "tyle_phutai1", "label": "Load profile 1 (%)", "horizontalalignment": "right" },
          { "name": "pmax2", "label": "PMax 2 (kW)", "horizontalalignment": "right" },
          { "name": "pmax2_time", "label": "Time PMax 2", "horizontalalignment": "right" },
          { "name": "tyle_phutai2", "label": "Load profile 2 (%)", "horizontalalignment": "right" },
          { "name": "pmax3", "label": "PMax 3 (kW)", "horizontalalignment": "right" },
          { "name": "pmax3_time", "label": "Time PMax 3", "horizontalalignment": "right" },
          { "name": "tyle_phutai3", "label": "Load profile 3 (%)", "horizontalalignment": "right" }

        ];
      } else {
        cols = [
          { "name": "stt", "label": "STT", "horizontalalignment": "center" },
          { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
          { "name": "tenkhachhang", "label": "Tên điểm đo", "horizontalalignment": "left" },
          { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
          { "name": "timemeter", "label": "Thời gian công tơ", "horizontalalignment": "center" },
          { "name": "time", "label": "Thời gian hệ thống", "horizontalalignment": "center" },
          { "name": "tu", "label": "TU công tơ", "horizontalalignment": "left" },
          { "name": "ti", "label": "TI công tơ", "horizontalalignment": "left" },
          { "name": "hsn", "label": "HSN trong công tơ", "horizontalalignment": "left" },
          { "name": "loaicongto", "label": "Chủng loại công tơ", "horizontalalignment": "left" },
          { "name": "pgiao1", "label": "P giao 1 (KWh)", "horizontalalignment": "right" },
          { "name": "pgiao2", "label": "P giao 2 (KWh)", "horizontalalignment": "right" },
          { "name": "pgiao3", "label": "P giao 3 (KWh)", "horizontalalignment": "right" },
          { "name": "pgiaotong", "label": "Σ P giao (KWh)", "horizontalalignment": "right" },

          { "name": "pnhan1", "label": "P nhận 1 (KVarh)", "horizontalalignment": "right" },
          { "name": "pnhan2", "label": "P nhận 2 (KVarh)", "horizontalalignment": "right" },
          { "name": "pnhan3", "label": "P nhận 3 (KVarh)", "horizontalalignment": "right" },
          { "name": "pnhantong", "label": "Σ P nhận 3 (KVarh)", "horizontalalignment": "right" },
          { "name": "qgiaotong", "label": "ΣQ giao (KVarh)", "horizontalalignment": "right" },
          { "name": "qnhantong", "label": "ΣQ nhận (KVarh)", "horizontalalignment": "right" },
          { "name": "pmax1", "label": "PMax 1 (kW)", "horizontalalignment": "right" },
          { "name": "pmax1_time", "label": "Time PMax 1", "horizontalalignment": "right" },
          { "name": "tyle_phutai1", "label": "Phụ tải biểu 1 (%)", "horizontalalignment": "right" },
          { "name": "pmax2", "label": "PMax 2 (kW)", "horizontalalignment": "right" },
          { "name": "pmax2_time", "label": "Time PMax 2", "horizontalalignment": "right" },
          { "name": "tyle_phutai2", "label": "Phụ tải biểu 2 (%)", "horizontalalignment": "right" },
          { "name": "pmax3", "label": "PMax 3 (kW)", "horizontalalignment": "right" },
          { "name": "pmax3_time", "label": "Time PMax 3", "horizontalalignment": "right" },
          { "name": "tyle_phutai3", "label": "Phụ tải biểu 3 (%)", "horizontalalignment": "right" }

        ];
      }

    }
    else {
      if (language == "en") {
        cols = [
          { "name": "stt", "label": "No", "horizontalalignment": "center" },
          { "name": "imei", "label": "IMEI", "horizontalalignment": "left" },
          { "name": "socongto", "label": "Meter number", "horizontalalignment": "left" },
          { "name": "loaicongto", "label": "Meter type", "horizontalalignment": "left" },
          { "name": "madiemdo", "label": "Measurement point code", "horizontalalignment": "left" },
          { "name": "tenkhachhang", "label": "Customer name", "horizontalalignment": "left" },
          { "name": "matram", "label": "Substation Code", "horizontalalignment": "left" },
          { "name": "macot", "label": "Poles Code", "horizontalalignment": "left" },
          // { "name": "masoghi", "label": "Mã sổ ghi", "horizontalalignment": "left" },
          { "name": "marepeater", "label": "Repeater No", "horizontalalignment": "left" },
        ];
      } else {
        cols = [
          { "name": "stt", "label": "STT", "horizontalalignment": "center" },
          { "name": "imei", "label": "IMEI", "horizontalalignment": "left" },
          { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
          { "name": "loaicongto", "label": "Loại công tơ", "horizontalalignment": "left" },
          { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
          { "name": "tenkhachhang", "label": "Tên khách hàng", "horizontalalignment": "left" },
          { "name": "matram", "label": "Mã trạm", "horizontalalignment": "left" },
          { "name": "macot", "label": "Mã cột", "horizontalalignment": "left" },
          { "name": "masoghi", "label": "Mã sổ ghi", "horizontalalignment": "left" },
          { "name": "marepeater", "label": "Mã repeater", "horizontalalignment": "left" },
        ];
      }
    }
    let curUs = this.user.getCurrentUser();
    var param = {

      config: JSON.stringify({ namesql: "PKG_THONGSOVANHANH.P_LAYDS_CHISOCTO" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid,
        v_locdulieu: locdulieu,
        v_loaihienthi: loaihienthi,
        v_ngay: ngay,
        v_gio: gio,
        v_loaipha: loaipha,
        v_sotrang: sotrang,
        v_sodong: sodong,
        v_mataikhoan: curUs.mataikhoan,
        v_ip: "",
        v_loaichiso: loaichiso,
        v_duan: duan
      }),
      title: tenchucnang + " " + tendonvi,//+ " " + thoidiemtruyvan,
      header: "Ngày: " + thoidiemtruyvan,
      filename: tendonvi + "_" + tenchucnang + "_" + thoidiemtruyvan,
      sheets: tenchucnang,
      columns: cols,
      data: ""
    };
    var filename = tendonvi + "_" + tenchucnang + "_" + thoidiemtruyvan;

    return this.api.downloadFile("api/ExportExcel", param, filename);
  }





  getDsCongto(meterid) {
    var param = {
      "config": '{"namesql":"PKG_KHACHHANG.P_LAYDS_CONGTO"}',
      "para": '{"v_meterid":"' + meterid + '"}'
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }
  getConfig(key) {
    return this.api.getConfigValue(key);
  }


}





// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/giam-sat/chi-so-cong-to-kh/chisocongtokh.service.ts